import $ from 'jquery';

export default class Select {
	constructor() {
		this.selectors = {
			select: '.js-select',
			current: '.js-select-current',
			currentText: '.js-select-current-text',
			currentSizeFirst: '.js-select-first-current',
			currentSizeSecond: '.js-select-second-current',
			currentColor: '.js-select-current-color',
			text: '.js-select-text',
			color: '.js-select-color',
			sizeFirst: '.js-select-size-first',
			sizeSecond: '.js-select-size-second',
			item: '.js-select-item',
			body: '.js-select-body',
			input: '.js-select-input'
		};

		this.classes = {
			open: 'select_state_open',
			error: 'select_state_error'
		};

		this.$select = $(this.selectors.select);
	}

	getDom = () => {
		this.$text = $(this.selectors.text);
		this.$color = $(this.selectors.color);
		this.$sizeFirst = $(this.selectors.sizeFirst);
		this.$sizeSecond = $(this.selectors.sizeSecond);
		this.$currentText = $(this.selectors.currentText);
		this.$currentColor = $(this.selectors.currentColor);
		this.$currentSizeFirst = $(this.selectors.currentSizeFirst);
		this.$currentSizeSecond = $(this.selectors.currentSizeSecond);
		this.$item = $(this.selectors.item);
		this.$input = $(this.selectors.input);
	}

	toggle = e => {
		e.stopPropagation();
		const $target = $(e.target);
		const $select = $target.closest(this.$select);
		this.$select.not($select).removeClass(this.classes.open);
		$select.toggleClass(this.classes.open);
		$select.removeClass(this.classes.error);
	}

	close = e => {
		const $target = $(e.target);

		if (!$target.closest(this.$select).length) {
			this.$select.removeClass(this.classes.open);
		}
	}

	setData($target) {
		const $select = $target.closest(this.$select);
		const text = $target.find(this.$text).text();
		const sizeFirst = $target.find(this.$sizeFirst).text();
		const sizeSecond = $target.find(this.$sizeSecond).text();
		const color = $target.find(this.$color).attr('style');
		const value = $target.data('value');

		this.setText($select, text, sizeFirst, sizeSecond);
		this.setColor($select, color);
		this.setValue($select, value);
		this.setSelected($select, $target);

	}

	setText(select, text, sizeFirst, sizeSecond) {
		const $curText = select.find(this.$currentText);
		const $curSizeFirst = select.find(this.$currentSizeFirst);
		const $curSizeSecond = select.find(this.$currentSizeSecond);
		$curText.text(text);
		$curSizeFirst.text(sizeFirst);
		$curSizeSecond.text(sizeSecond + ' –');
	}

	setColor(select, color) {
		const $curColor = select.find(this.$currentColor);
		$curColor.attr('style', color);
	}

	setValue(select, value) {
		const $input = select.find(this.$input);
		$input.val(value);
		this.$select.removeClass(this.classes.open);
	}

	setSelected(select, item) {
		const $items = select.find(this.$item);
		$items.attr('data-selected', null);
		item.attr('data-selected', 'true');
	}

	onClick = e => {
		e.stopPropagation();
		const $target = $(e.currentTarget);
		const $select = $target.closest(this.selectors.select);
		this.setData($target);
		$select.trigger('select');
	}

	onLoad = () => {
		const $selected = this.$item.filter('[data-selected="true"]');
		const self = this;
		$selected.each(function () {
			const $this = $(this);
			self.setData($this);
		});
	}

	setHandlers = () => {
		this.$select.on('click', this.toggle);
		this.$item.on('click', this.onClick);
		$(document).on('click', this.close);
		$(window).on('load', this.onLoad);
	}

	render = () => {
		if (this.$select.length) {
			this.getDom();
			this.setHandlers();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/select/select.js
 **/